import { render, staticRenderFns } from "./id-v2.vue?vue&type=template&id=7adbf150&scoped=true&"
import script from "./id-v2.vue?vue&type=script&lang=js&"
export * from "./id-v2.vue?vue&type=script&lang=js&"
import style0 from "./id-v2.vue?vue&type=style&index=0&id=7adbf150&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adbf150",
  null
  
)

export default component.exports